export default __webpack_public_path__ + "static/media/canon-catapult-Front-view.93c089c4.gif";